const { context } = require('../app-context');
const AuthPersistence = require('services/auth-management/persistence');
const AuthDebug = require('services/auth-management/debug');
const AuthStateTransitions = require('services/auth-management/state-transitions');
const {
    hasWelcomeEmailContext,
    isChoosePasswordRoute
} = require('utils/signup-context');

module.exports = (store) => {

    const selectors = context.selectors.all;
    const actions = context.actions;
    const redux = context.redux.hooks;

    let authPersistenceState = AuthPersistence.getInitialAuthPersistenceState();

    store.subscribe(() => {

        const nextState = AuthPersistence.syncSavedAuthToken({
            selectors,
            store,
            previousToken: authPersistenceState.previousToken
        });

        authPersistenceState = {
            ...authPersistenceState,
            ...nextState
        };
    });

    window.addEventListener('storage', (event) => {

        authPersistenceState = AuthPersistence.handleCrossTabTokenRemoval({
            actions,
            authPersistenceState,
            event,
            redux,
            selectors,
            store
        });
    });
    AuthPersistence.subscribeLoginContextStorage({ store });
    AuthPersistence.subscribeSignupContextStorage({ store });
    AuthPersistence.subscribeMfaContextStorage({ store });

    if (hasWelcomeEmailContext(window.location)) {
        AuthStateTransitions.resetForWelcomeLink();
    }

    const shouldClearSavedSession = !!authPersistenceState.previousToken
        && isChoosePasswordRoute(window.location);
    const initialAuthAction = shouldClearSavedSession
        ? actions.auth.logoutSync({ redirect: false })
        : actions.auth.login({ token: authPersistenceState.previousToken });

    redux.dispatch(initialAuthAction);

    window.redux = redux;
    AuthDebug.installDeveloperConsole({
        redux,
        selectors,
        store
    });
};
